<template>
  <div>
    <ul class="nav nav-tabs">
      <li class="nav-item" v-for="(playersGroup, round) in filteredPlayers" :key="round">
        <a
            class="nav-link"
            :class="{ active: activeTab === round }"
            href="#"
            @click.prevent="activeTab = round"
        >
          {{ getRoundTitle(round) }}
        </a>
      </li>
    </ul>
    <div class="tab-content">
      <div
          v-for="(playersGroup, round) in filteredPlayers"
          :key="round"
          :class="['tab-pane', { 'show active': activeTab === round }]"
      >
        <div class="bracket-grid">
          <div class="round">
            <h3>{{ getRoundTitle(round) }}</h3>
            <div class="matchups">
              <div v-for="(matchup, matchupIndex) in getMatchupsForRound(playersGroup)" :key="matchupIndex" class="matchup">
                <div class="player">
                  <span class="player-name">{{ getPlayerName(matchup[0]) }}</span>
                  <span class="player-score">{{ getPlayerScore(matchup[0]) }}</span>
                </div>
                <div class="vs">VS</div>
                <div class="player">
                  <span class="player-name">{{ getPlayerName(matchup[1]) }}</span>
                  <span class="player-score">{{ getPlayerScore(matchup[1]) }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BracketGrid',
  props: {
    players: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      activeTab: 'round32',
      localPlayers: JSON.parse(JSON.stringify(this.players)) // Copia profunda de players
    };
  },
  watch: {
    players: {
      handler(newPlayers) {
        this.localPlayers = JSON.parse(JSON.stringify(newPlayers));
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    filteredPlayers() {
      return Object.fromEntries(
          Object.entries(this.localPlayers).filter(([playersGroup]) => playersGroup.length > 0)
      );
    }
  },
  methods: {
    getRoundTitle(round) {
      const roundTitles = {
        round32: 'Dieciseisavos',
        round16: 'Octavos',
        round8: 'Cuartos',
        round4: 'Semifinal',
        thirdPlace: 'Tercer Puesto',
        roundFinal: 'Final'
      };
      return roundTitles[round] || round;
    },
    getMatchupsForRound(playersGroup) {
      let matchups = [];
      for (let i = 0; i < playersGroup.length; i += 2) {
        matchups.push([playersGroup[i], playersGroup[i + 1]]);
      }
      return matchups;
    },
    getPlayerName(player) {
      return player ? player.name : 'Loading...';
    },
    getPlayerScore(player) {
      return player && player.total_score !== null ? player.total_score : 'Loading...';
    }
  }
};
</script>

<style scoped>
.nav-tabs {
  margin-bottom: 20px;
}
.nav-item {
  cursor: pointer;
}
.nav-link {
  cursor: pointer;
}
.tab-content {
  display: flex;
  justify-content: center;
}
.tab-pane {
  display: none;
}
.tab-pane.show.active {
  display: block;
}
.bracket-grid {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.round {
  margin: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.matchups {
  display: flex;
  flex-direction: column;
}
.matchup {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin: 10px 0;
}
.player {
  width: 150px;
  border: 1px solid #ccc;
  margin: 5px;
  padding: 10px;
  text-align: center;
}
.player-name {
  font-weight: bold;
}
.player-score {
  margin-top: 5px;
  display: block;
}
.vs {
  font-size: 24px;
  font-weight: bold;
  margin: 0 10px;
}
</style>
